import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent, IIdentityEvent } from '../../../common/events/identity'
import { KruxEvent } from '../../../common/events/krux'

export interface IWindow extends Window {
    Krux: any
    KruxDataLayer: any
}

declare let window: IWindow

interface IKruxEvent {
    event_id: string
    event_type: string
    [key: string]: string
}

export class Krux {
        private kruxJsPath = '//cdn.krxd.net/controltag/'
        /**
         * Read krux user id from the localstorage/cookie and set in the global variable
         * The below method closely resembles the interchange snippet from Salesforce Audience Studio
         * Ref. https://konsole.zendesk.com/hc/en-us/articles/215645678-Interchange-O-O-Implementation-Guide
         */
        public static getKruxUser() {
            if (!window.Krux) {
                window.Krux = (args: any) => window.Krux.q.push(args)
                window.Krux.q = []
            }

            window.Krux.user = this.retrieveKruxValue('user')
            window.Krux.segments = this.retrieveKruxValue('segs') ? this.retrieveKruxValue('segs').split(',') : []
            return window.Krux.user

        }
        /**
         * Get krux user id from the localstorage/cookie
         */
        private static retrieveKruxValue(key='user') {

            const kuidrBowserStorageKey = 'kxpostmedia_' + key
            let kruxBrowserValue = ''
            if (window.localStorage) {

                kruxBrowserValue  = window.localStorage.getItem(kuidrBowserStorageKey) || ''
            } else if (navigator.cookieEnabled) {
                const kuidStoredValue = document.cookie.match(kuidrBowserStorageKey+'=([^;]*)')
                kruxBrowserValue = (kuidStoredValue && unescape(kuidStoredValue[1])) || ''
            } else {
                kruxBrowserValue = ''
            }
            return kruxBrowserValue
        }
        /**
         * Loads JS library for given account.
         */
        public init(account: string) {
            // multiple providers are supported, so fetch conf by name
            if (account) {
                // setup global object
                if (!window.Krux) {
                    window.Krux = (args: any) => window.Krux.q.push(args)
                    window.Krux.q = []
                }

                // initiate KruxDataLayer
                if (!window.KruxDataLayer) {
                    window.KruxDataLayer = {}
                    window.KruxDataLayer.data = {}
                }

                // injecting mParticle ID into Krux data object
                addEventListener(IdentityEvent.PROVIDER_ID_ASSIGNED, (e: IIdentityEvent) => {
                    if (e.detail.mpId) {
                        window.KruxDataLayer.data.MPID = e.detail.mpId
                    } else {
                        window.KruxDataLayer.data.MPID = undefined
                    }
                })

                // load JS script and send page view
                addEventListener(KruxEvent.FIRE_PAGE_VIEW, (e: CustomEvent) => {
                    // expose page data for Krux
                    window.KruxDataLayer.data = {
                        ...e.detail,
                        ...window.KruxDataLayer.data
                    }

                    DOMUtils.loadScript(`${this.kruxJsPath}${account}.js`)
                })
            } else {
                console.warn('Krux account id not provided')
            }
        }

        // Send async view based on Krux data layer
        public sendAsyncView(dataLayer: any) {
            // expose page data for Krux
            window.KruxDataLayer.data = dataLayer
            window.Krux('ns:postmedia', 'page:load', (err: any) => {
                if(err) {
                    console.error(err)
                }
            }, { pageView: true })
        }

        // send events with attributes to Krux
        public sendEvent(dataAttrs: IKruxEvent) {
            const {event_id, ...evtAttrs} = dataAttrs
            window.Krux('ns:postmedia', 'admEvent', event_id, evtAttrs)
        }
    }
